<template>
  <div class="c--menus_left">
    <div class="bg-white box-rounded shadowed overflow-hidden">
      <div>
        <template v-if="forUser">
          <UserBox
            :user-name="userName"
            :user-rank-title="userStatusTitle"
            :user-rank-image-url="userStatusImageUrl"
            class="border-b border-b-solid color-border-bottom-lighter mb-30"
          />
        </template>
        <template v-else>
          <h3 class="left-menu-title typo-h2 px-30 py-25 mb-30 border-b border-b-solid color-border-bottom-lighter">
            {{ title }}
          </h3>
        </template>

        <ul class="d-grid gap-10 px-30 pb-30">
          <li v-for="(item, index) in leftMenu" :key="index">
            <template v-if="item.route && item.isExternalRoute">
              <a
                :href="item.route"
                :data-testid="`${item.key}-button`"
                target="_blank"
                class="menu-item typo-h5 color-text-secondary text-decoration-none display-flex px-20 py-5px"
              >
                {{ $t(item.key) }}
              </a>
            </template>
            <template v-else>
              <nuxt-link
                @click.native="clickHandler(item)"
                :to="localePath(item.route)"
                :data-testid="`${item.key}-button`"
                class="menu-item typo-h5 color-text-secondary text-decoration-none display-flex px-20 py-5px"
              >
                {{ $t(item.key) }}
              </nuxt-link>
            </template>
          </li>
        </ul>
      </div>
    </div>
    <div v-if="logOutItem">
      <div class="px-30 mt-30 display-none display-lg-block">
        <a
          class="left-menu-logout typo-p color-text-red display-flex justify-content-start align-items-center text-decoration-none cursor-pointer"
          @click.prevent="onClickLogout"
        >
          <span>
            {{ $t('components.main.navigation.logout') }}
          </span>
          <span :class="['display-flex', { 'ml-10': $dir() === 'ltr', 'mr-10': $dir() === 'rtl' }]">
            <span
              :class="[
                'airalo-icon-log-out tw-text-4',
                {
                  'rtl-transform-rotate-y': $dir() === 'rtl',
                },
              ]"
            />
          </span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  import UserBox from '~/components/shared/user-box.vue'

  export default {
    components: {
      UserBox,
    },

    props: {
      forUser: {
        type: Boolean,
        required: false,
        default: false,
      },
      title: {
        type: String,
        required: false,
        default: '',
      },
      userName: {
        type: String,
        required: false,
        default: '',
      },
      userBadge: {
        type: Object,
        required: false,
        default: null,
      },
      list: {
        type: Array,
        required: true,
      },
    },

    computed: {
      leftMenu() {
        if (this.list.length === 0) return null

        return this.list.filter((v) => !v.isLogOut)
      },

      logOutItem() {
        if (this.list.length === 0) return null

        return this.list.find((v) => v.isLogOut)
      },
      userStatusTitle() {
        return this.userBadge?.title
      },
      userStatusImageUrl() {
        return this.userBadge?.image?.url
      },
    },

    methods: {
      onClickLogout() {
        this.$store.commit('set_logout_modal_visibility', true)
      },
      clickHandler(item) {
        this.$utils.sendEvent('mainNavigation', {
          text: this.$t(item.key),
          url: this.localePath({ name: item.route.name }),
        })
      },
    },
  }
</script>

<style lang="scss" scoped>
  .menu {
    &-item {
      border-left: 2px solid transparent;

      &.nuxt-link-active,
      &.nuxt-link-exact-active {
        color: #4a4a4a;
        border-left-color: #4a4a4a;
      }

      [dir='rtl'] & {
        border-left: unset;
        border-right: 2px solid transparent;

        &.nuxt-link-active,
        &.nuxt-link-exact-active {
          border-left-color: unset;
          border-right-color: #4a4a4a;
        }
      }
    }
  }
</style>
